import React, { useMemo } from 'react'
import { ContactDetailsInfoContainer, FormInfoWrapper } from './style'
import { Divider } from 'antd'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../redux/store'

// const CareGiverDetails = () => {
//   return (
//     <ContactDetailsInfoContainer>
//       <p>Primary Caregiver</p>
//       <Divider />
//       {clientContactDetails.label.map((value, index) => (
//         <FormInfoWrapper key={index}>
//           <div>{value}</div>
//           <div>{clientContactDetails.primaryCaregiver[index]}</div>
//         </FormInfoWrapper>
//       ))}
//       <p>Secondary Caregiver</p>
//       <Divider />
//       {clientContactDetails.label.map((value, index) => (
//         <FormInfoWrapper key={index}>
//           <div>{value}</div>
//           <div>{clientContactDetails.secondaryCaregiver[index]}</div>
//         </FormInfoWrapper>
//       ))}
//       <p>Family Details</p>
//       <Divider />
//       {clientContactDetails.familyDetails.map((familyDetails, index) => (
//         <FormInfoWrapper key={index}>
//           <div>{familyDetails.label}</div>
//           <div>{familyDetails.value}</div>
//         </FormInfoWrapper>
//       ))}
//     </ContactDetailsInfoContainer>
//   )
// };

const ContactDetailsInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  // const { user } = useSelector((state: RootState) => state.auth);

  const haveChildren = useMemo(() => {
    if (selectedClient?.familyDetail?.numberOfMaleChildren && selectedClient?.familyDetail?.numberOfFemaleChildren) {
      const maleChildren = selectedClient?.familyDetail?.numberOfMaleChildren;
      const femaleChildren = selectedClient?.familyDetail?.numberOfFemaleChildren;
      return (maleChildren + femaleChildren) > 0 ? 'Yes' : 'No';
    }
    return 'No';
  }, [selectedClient]);

  return (
    <ContactDetailsInfoContainer>
      <FormInfoWrapper>
        <div>Telephone number</div>
        <div>{selectedClient?.personalContactDetail?.telephoneNumber}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Country</div>
        <div>{selectedClient?.personalContactDetail?.addressCountry}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Street</div>
        <div>{selectedClient?.personalContactDetail?.addressStreet}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Number (+Additional)</div>
        {/* Not sure what to put here */}
        <div></div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Place</div>
        <div>{selectedClient?.personalContactDetail?.addressPlace}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Postal Code</div>
        <div>{selectedClient?.personalContactDetail?.addressPostalCode}</div>
      </FormInfoWrapper>
      <p>Education, Profession</p>
      <Divider />
      <FormInfoWrapper>
        <div>Profession</div>
        <div>{selectedClient?.careerAndEducationDetail?.profession}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Education</div>
        <div>{selectedClient?.careerAndEducationDetail?.educationLevel}</div>
      </FormInfoWrapper>
      <p>Family details</p>
      <Divider />
      <FormInfoWrapper>
        <div>Marital status</div>
        <div>{selectedClient?.familyDetail?.maritalStatus}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Do you have children?</div>
        <div>{haveChildren}</div>
      </FormInfoWrapper>
    </ContactDetailsInfoContainer>
  )
}

export default ContactDetailsInfo;